{
  "CANNED_MGMT": {
    "HEADER": "定型文",
    "LEARN_MORE": "定型文について詳しく学ぶ",
    "DESCRIPTION": "定型文は、会話に迅速に返信するための事前に書かれた返信テンプレートです。担当者は '/' 文字の後にショートコードを入力することで、会話中に定型文を挿入できます。",
    "COUNT": "{n} canned response | {n} canned responses",
    "HEADER_BTN_TXT": "定型文を追加",
    "LOADING": "定型文を取得中...",
    "SEARCH_PLACEHOLDER": "Search canned responses...",
    "NO_RESULTS": "No canned responses found matching your search",
    "SEARCH_404": "検索内容（クエリ）に一致する項目はありませんでした。",
    "LIST": {
      "404": "このアカウントには、利用可能な定型文の回答はありません。",
      "TITLE": "定型文回答を管理する",
      "DESC": "定型文は事前に定義された返信テンプレートで、会話に迅速に返信を送信する際に使用されます。",
      "TABLE_HEADER": {
        "SHORT_CODE": "ショートコード",
        "CONTENT": "内容",
        "ACTIONS": "操作"
      }
    },
    "ADD": {
      "TITLE": "定型文を追加",
      "DESC": "定型文は事前に定義された返信テンプレートで、会話に迅速に返信を送信する際に使用されます。",
      "CANCEL_BUTTON_TEXT": "キャンセル",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "ショートコード",
          "PLACEHOLDER": "ショートコードを入力してください。",
          "ERROR": "ショートコードは必須です。"
        },
        "CONTENT": {
          "LABEL": "メッセージ",
          "PLACEHOLDER": "後でテンプレートとして使用するメッセージを入力してください。",
          "ERROR": "メッセージは必須です。"
        },
        "SUBMIT": "送信"
      },
      "API": {
        "SUCCESS_MESSAGE": "定型文が正常に追加されました。",
        "ERROR_MESSAGE": "Woot Serverに接続できませんでした。後でもう一度お試しください。"
      }
    },
    "EDIT": {
      "TITLE": "定型文を編集",
      "CANCEL_BUTTON_TEXT": "キャンセル",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "ショートコード",
          "PLACEHOLDER": "ショートコードを入力してください。",
          "ERROR": "ショートコードは必須です。"
        },
        "CONTENT": {
          "LABEL": "メッセージ",
          "PLACEHOLDER": "後でテンプレートとして使用するメッセージを入力してください。",
          "ERROR": "メッセージは必須です。"
        },
        "SUBMIT": "送信"
      },
      "BUTTON_TEXT": "編集",
      "API": {
        "SUCCESS_MESSAGE": "定型文が正常に更新されました。",
        "ERROR_MESSAGE": "Woot Serverに接続できませんでした。後でもう一度お試しください。"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "削除",
      "API": {
        "SUCCESS_MESSAGE": "定型文が正常に削除されました。",
        "ERROR_MESSAGE": "Woot Serverに接続できませんでした。後でもう一度お試しください。"
      },
      "CONFIRM": {
        "TITLE": "削除の確認",
        "MESSAGE": "削除してもよろしいですか？",
        "YES": "はい、削除します",
        "NO": "いいえ、保持します"
      }
    }
  }
}
